$ = require 'jquery'
_ = require 'underscore'
Confirm = require 'app/scripts/views/lib/confirm'
Hearsay = require 'hearsay'
PopOver = require 'app/scripts/views/lib/pop-over'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginSectionRemoveAttachmentsView = require 'app/scripts/views/plugin/plugin-section-remove-attachments-view'
PluginView = require 'app/scripts/views/plugin/plugin-view'
Promise = require 'bluebird'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
sandboxParams = require 'app/scripts/data/plugin-iframe-sandbox'
{ sendPluginScreenEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
t = require('app/scripts/views/internal/teacup-with-helpers')('plugin_section')
{ track } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'
{ IconDefaultColor } = require '@trello/nachos'

template = t.renderable (data) ->
  { canRemove, content, popoverIsVisible } = data
  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title.window-module-title-no-divider', ->
      t.span '.window-module-title-icon.icon-lg.plugin-section-icon.js-icon'
      t.h3 '.u-inline-block.plugin-section-title.js-title'
      t.div '.window-module-title-options', ->
        if canRemove
          t.a '.quiet.js-remove', { href: '#' }, ->
            t.format 'remove'
            return
        return
      return

    if content.type == 'iframe' && pluginValidators.isValidUrlForIframe(content.url)
      { url, height } = content
      if !pluginValidators.isValidHeight(height)
        height = undefined
      t.div class: t.classify({
        'u-gutter': true,
        'js-plugin-iframe-container': true,
        'plugin-iframe-container-pop-over-shown': popoverIsVisible
      }), ->
        t.iframe '.plugin-iframe.plugin-section',
          allow: 'microphone; camera'
          sandbox: sandboxParams
          src: url
          style: t.stylify
            height: if height then "#{ height }px;" else undefined
        t.div '.plugin-iframe-popover-overlay'
        return
    return
  return

module.exports = class PluginSectionView extends PluginView
  initialize: ->
    @section = new Hearsay.Slot(null)

  renderOnce: ->
    section = @section.get()
    if !section?
      throw Error('updateSection not called before render')

    @$el.html(
      template(
        Object.assign({}, section, canRemove: @model.editable(), popoverIsVisible: PopOver.isVisible)
      )
    )

    @subscribe @section, (latestSection) =>
      Promise.resolve(_.result(latestSection, 'title'))
      .then (title) =>
        @$('.js-title').text(title)
      .catch PluginRunner.Error.Timeout, (->)

      Promise.resolve(_.result(latestSection, 'icon'))
      .then (icon) =>
        iconUrl = t.addRecolorParam(icon, "?color=#{ IconDefaultColor.substr(1).toLowerCase() }")
        @$('.js-icon')
          .css('background-image', t.urlify(iconUrl))
          .toggleClass('mod-reset', latestSection.monochrome == false)
      .catch PluginRunner.Error.Timeout, (->)

    @initIFrames(@model.getBoard(), @model, @section)

    claimed = section.claimed || []
    sendPluginScreenEvent({
      idPlugin: section.idPlugin
      idBoard: @model.getBoard().id
      idCard: @model.id
      screenName: 'pupAttachmentSectionInlineDialog'
      attributes:
        totalAttachments: claimed.length
    })

    @

  updateSection: (section) ->
    @retain(section)
    @section.set(section)

  events:
    'click .js-remove': 'confirmRemove'

  confirmRemove: (e) ->
    Util.stop(e)

    section = @section.get()

    if section.claimed.length == 1
      model = @model.attachmentList.get(section.claimed[0].id)
      Confirm.toggle 'remove attachment',
        elem: @$(e.currentTarget)
        model: model
        confirmBtnClass: 'negate'
        fxConfirm: (e) =>
          model.destroy()
          track("Attachment", "Delete Attachment", model.getType())
    else
      PopOver.toggle
        elem: $(e.currentTarget)
        view: new PluginSectionRemoveAttachmentsView({ @model, section })

    return
